import { useEffect } from "react";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { FeatureStrip } from "./components/site/FeatureStrip";
import { Cottages } from "./components/site/Cottages";
import { About } from "./components/site/About";
import { Activities } from "./components/site/Activities";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { CottagePage } from "./components/site/CottagePage";
import { COTTAGES } from "./data/cottages";
import { scrollToId } from "./components/site/scroll";

const LandingPage = () => {
  useEffect(() => {
    let frame;

    // Coming from a cottage detail page loads the homepage before React
    // renders #kontakt. Native browser anchor scrolling can therefore miss it.
    const followHash = () => {
      const hash = window.location.hash.slice(1);
      if (!hash) return;
      let id = hash;
      try { id = decodeURIComponent(hash); } catch { /* keep raw hash */ }
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => scrollToId(id, { instant: true }));
    };

    followHash();
    window.addEventListener("hashchange", followHash);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("hashchange", followHash);
    };
  }, []);

  return (
  <div className="site">
    <Header />
    <main>
      <Hero />
      <FeatureStrip />
      <Cottages />
      <About />
      <Activities />
      <Contact />
    </main>
    <Footer />
  </div>
  );
};

const SiteRoute = () => {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path.startsWith("/stugor/")) {
    const key = path.split("/").filter(Boolean).pop();
    const cottage = COTTAGES.find((item) => item.key === key);
    if (cottage) return <CottagePage cottage={cottage} />;
  }
  return <LandingPage />;
};

function App() {
  return (
    <LanguageProvider>
      <SiteRoute />
    </LanguageProvider>
  );
}

export default App;
